/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BatchTaskStatusEnum } from './BatchTaskStatusEnum';
import {
  BatchTaskStatusEnumFromJSON,
  BatchTaskStatusEnumFromJSONTyped,
  BatchTaskStatusEnumToJSON,
} from './BatchTaskStatusEnum';

/**
 *
 * @export
 * @interface BatchDownloadStartResponse
 */
export interface BatchDownloadStartResponse {
  /**
   *
   * @type {string}
   * @memberof BatchDownloadStartResponse
   */
  taskId: string;
  /**
   *
   * @type {BatchTaskStatusEnum}
   * @memberof BatchDownloadStartResponse
   */
  status?: BatchTaskStatusEnum;
  /**
   *
   * @type {string}
   * @memberof BatchDownloadStartResponse
   */
  url?: string | null;
  /**
   *
   * @type {string}
   * @memberof BatchDownloadStartResponse
   */
  error?: string | null;
  /**
   *
   * @type {number}
   * @memberof BatchDownloadStartResponse
   */
  progress?: number | null;
}

/**
 * Check if a given object implements the BatchDownloadStartResponse interface.
 */
export function instanceOfBatchDownloadStartResponse(value: object): value is BatchDownloadStartResponse {
  if (!('taskId' in value) || value['taskId'] === undefined) return false;
  return true;
}

export function BatchDownloadStartResponseFromJSON(json: any): BatchDownloadStartResponse {
  return BatchDownloadStartResponseFromJSONTyped(json, false);
}

export function BatchDownloadStartResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): BatchDownloadStartResponse {
  if (json == null) {
    return json;
  }
  return {
    taskId: json['task_id'],
    status: json['status'] == null ? undefined : BatchTaskStatusEnumFromJSON(json['status']),
    url: json['url'] == null ? undefined : json['url'],
    error: json['error'] == null ? undefined : json['error'],
    progress: json['progress'] == null ? undefined : json['progress'],
  };
}

export function BatchDownloadStartResponseToJSON(value?: BatchDownloadStartResponse | null): any {
  if (value == null) {
    return value;
  }
  return {
    task_id: value['taskId'],
    status: BatchTaskStatusEnumToJSON(value['status']),
    url: value['url'],
    error: value['error'],
    progress: value['progress'],
  };
}
